/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../types/types';
import ThemeIconProvider from './ThemeIconProvider';
import {useIconDLS} from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Side Nav Events  Icon component.
 */
export const SideNavEventsIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <ThemeIconProvider name='SideNavEventsIcon' {...props} legacyIcon={(
      <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none'>
        <path d="M19 10.3125C19 9.67058 19 8.85365 19 8M8.59375 21H2C1.44772 21 1 20.5523 1 20V4C1 3.44772 1.44772 3 2 3H4M16 3H18C18.5523 3 19 3.44686 19 3.99914C19 4.98272 19 6.54472 19 8M16 3V0M16 3H4M4 3V0M19 8H10.5H1.5"
          stroke={iconColor}
          strokeWidth={1.5}/>
        <path d="M20.25 17C20.25 19.8995 17.8995 22.25 15 22.25C12.1005 22.25 9.75 19.8995 9.75 17C9.75 14.1005 12.1005 11.75 15 11.75C17.8995 11.75 20.25 14.1005 20.25 17Z"
          stroke={iconColor}
          strokeWidth={1.5}/>
        <path d="M15 14L15 17.84L17.5 19" stroke={iconColor} strokeWidth={1.5}/>
      </svg>
    )} />
  );
};
